import React, { createContext, useContext, useState, useEffect } from 'react';
import { collection, onSnapshot, addDoc, updateDoc, deleteDoc, doc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

const NoticeContext = createContext({ notices: [], loading: true });

export const useNotices = () => useContext(NoticeContext);

export const NoticeProvider = ({ children }) => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, 'notices'), (snap) => {
      const list = snap.docs
        .map(d => ({ id: d.id, ...d.data() }))
        .sort((a, b) => {
          if (a.pinned && !b.pinned) return -1;
          if (!a.pinned && b.pinned) return 1;
          const aTime = a.createdAt?.toMillis?.() || 0;
          const bTime = b.createdAt?.toMillis?.() || 0;
          return bTime - aTime;
        });
      setNotices(list);
      setLoading(false);
    }, (err) => {
      console.error('공지 실시간 구독 실패:', err);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  const addNotice = async (data) => {
    await addDoc(collection(db, 'notices'), {
      ...data,
      pinned: false,
      author: '관리자',
      createdAt: serverTimestamp(),
    });
  };

  const updateNotice = async (id, data) => {
    await updateDoc(doc(db, 'notices', id), { ...data, updatedAt: serverTimestamp() });
  };

  const removeNotice = async (id) => {
    await deleteDoc(doc(db, 'notices', id));
  };

  const togglePin = async (id, current) => {
    await updateDoc(doc(db, 'notices', id), { pinned: !current });
  };

  return (
    <NoticeContext.Provider value={{ notices, loading, addNotice, updateNotice, removeNotice, togglePin }}>
      {children}
    </NoticeContext.Provider>
  );
};
